module.exports = __webpack_public_path__ + "static/img/bg.df9b84a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/bg.png
// module id = wTwL
// module chunks = 1